import {isMobileOnly, isTablet} from 'mobile-device-detect'
import {isIE, isEdge, isSafari} from 'mobile-device-detect'
const MOBILE_BREAKPOINT = 768

let deviceType = 'desktop'
//if(isTablet) deviceType = 'tablet'
if (isMobileOnly || window.outerWidth <= MOBILE_BREAKPOINT) deviceType = 'mobile'

export default deviceType

export let isBadImgLoaderBrowser =  isIE || isEdge || isSafari